var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"layout-container",attrs:{"no-gutters":""}},[_c('Sidebar'),_c('div',{staticClass:"content-wrapper"},[_c('Header'),_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }